export default "__VITE_IMAGE_ASSET__3b3c0c6f__";